<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Reservation"
    }
</script>

<style scoped>
</style>
